import axios from "../axiosInstance"

export const getAllClients = async () => {
  try {
    const res = await axios.get("/clients/all")
    const { data } = res
    return data.clients
  } catch (error) {
    console.error("Error fetching clients:", error)
    throw error
  }
}

export const getClientById = async (clientId: number) => {
  try {
    const res = await axios.get(`/clients/${clientId}`)
    return res.data.client
  } catch (error) {
    console.error("Error fetching client by id:", error)
    throw error
  }
}

export const getRecentClientCount = async () => {
  try {
    const res = await axios.get("/clients/data")
    const { data } = res
    return data.clientData
  } catch (error) {
    console.error("Error fetching recent client count:", error)
    throw error
  }
}

export const updateClientPhoneNumber = async (phoneNumber: string) => {
  try {
    const res = await axios.post("/client/phone", { phoneNumber })
    const { data } = res
    return data.user
  } catch (error) {
    console.error("Error updating client phone number:", error)
    throw error
  }
}

export const setTwoFactor = async (enabled: boolean) => {
  try {
    const res = await axios.post("/client/two-factor", { enabled })
    return res.data
  } catch (error) {
    console.error("Error setting two-factor preference:", error)
    throw error
  }
}

export const getClientContactInfo = async () => {
  try {
    const res = await axios.get("/client/contact-info")
    return res.data.contactInfo
  } catch (error) {
    console.error("Error fetching client contact info:", error)
    throw error
  }
}

export const requestContactInfoUpdate = async (changes: { field: string; from: string; to: string }[]) => {
  try {
    const res = await axios.post("/client/contact-info/request", { changes })
    return res.data
  } catch (error) {
    console.error("Error requesting contact info update:", error)
    throw error
  }
}

export const updateClientContactInfo = async (payload: {
  email?: string
  phone?: string
  address?: string
  city?: string
  state?: string
  zip?: string
  changes: { field: string; from: string; to: string }[]
}) => {
  try {
    const res = await axios.put("/client/contact-info/update", payload)
    return res.data
  } catch (error) {
    console.error("Error updating client contact info:", error)
    throw error
  }
}

// channel "email": send the code to the sign-in email instead of texting the new number.
export const sendAccountPhoneOtp = async ({ phoneNumber, channel }: { phoneNumber: string, channel?: "email" }) => {
  try {
    const res = await axios.post("/client/contact-info/send-otp", { phoneNumber, channel })
    return res.data
  } catch (error) {
    console.error("Error sending account phone OTP:", error)
    throw error
  }
}

export interface ContactInfoPendingChange {
  id: number
  createdAt: string
  status: string
  equityPartnerEmail: string | null
  changes?: { field: string; from: string; to: string }[]
}

export const getActivePendingContactChange = async (): Promise<ContactInfoPendingChange | null> => {
  try {
    const res = await axios.get("/client/contact-info/pending")
    return res.data?.pending ?? null
  } catch (error) {
    console.error("Error fetching pending contact change:", error)
    return null
  }
}